import {messAdapter} from "../slices/messages";


export const {
    selectById: messageById,
    selectAll: allMessages,
} = messAdapter.getSelectors((state: any)=> state.messages);
